import { isNumber } from "@bonusmap/shared_ui/library";
import { CollectorExtensionBase } from "./collector-extension-base.js"

export class profilesCollectorExtension extends CollectorExtensionBase {
    static webComponentName: string = "profiles-collector-extension";
    constructor() {
        super();
    }
    onCollectorReady(): void {
        const action = this.collector.action;
        if (action === "add") {
            const storedValues = sessionStorage.getItem('match-page-params');
            if (storedValues) {
                try {
                    const params = JSON.parse(storedValues);
                    const territorialId = params['territorialId'];
                    const profileAttributes = params['profileAttributes'];
                    if (territorialId && Array.isArray(profileAttributes)) {
                        // console.log("profilesCollectorExtension: Collector è pronto", this.collector, window.dataSource, action);
                        const residenza = territorialId;
                        const attribute_values = profileAttributes
                        window.dataSource['residenza'].value = residenza;
                        window.dataSource['attribute_values'].value = attribute_values;
                        //rimuove i dati dalla sessione
                        sessionStorage.removeItem('match-page-params');
                    }
                } catch (error) {

                }

            }
        }
    }
}